import useSWR from 'swr';

import { swrListAllOrchestrations } from '../../../utils/api_functions/listAllOrchestrations';

const useAllOrchestrations = (filterObj = {}) => {
  const {
    workspaces, status, taskRunStatus, timeRange
  } = filterObj;

  const taskRunStatusArr = taskRunStatus?.toLowerCase() === 'all' ? [] : [taskRunStatus.toLowerCase()];
  const workspaceIds = workspaces?.map(({ id }) => id);

  let killed;
  if (status.toLowerCase() === 'inactive') {
    killed = true;
  } else if (status.toLowerCase() !== 'all') {
    killed = false;
  }

  const {
    data, error, isLoading
  } = useSWR([workspaceIds, killed, taskRunStatusArr, timeRange, 'list-all-orchestrations'], swrListAllOrchestrations, {
    refreshInterval: 5000,
  })

  return ({
    data: data?.orchestrations || [],
    error,
    isLoading
  })
}

export default useAllOrchestrations;
